import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import CompetitionsIndex from "@/pages/CompetitionsIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/competitions/")({
  head: () => ({
    meta: [
      { title: "Football Predictions by Competition | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["leagues", "footballPredictions"] }).meta },
      { name: "description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
      { property: "og:title", content: "Football Predictions by Competition | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
      { name: "twitter:title", content: "Football Predictions by Competition | Statlign" },
      { name: "twitter:description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
    ],
  }),
  component: () => (
    <MainLayout>
      <CompetitionsIndex />
    </MainLayout>
  ),
});
